import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { Build, PowerSettingsNew } from "@material-ui/icons";
import { inject, observer } from "mobx-react";
import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { AuthStore } from "../../model/AuthStore";
import { LoggerFactory } from "../../logger";
import { AppVersion } from "./AppVersion";

const log = LoggerFactory.create("user menu");

export interface UserMenuProps {
  anchorEl?: null;
  /** Auth store injected by mobx */
  auth?: AuthStore;
  /** Additional menu items in the top right corner of the layout */
  customMenuItems?: ReactNode;
  /** Allows configuring which default buttons should be visible */
  buttonConfig: {
    logout: boolean;
    options: string | boolean;
  };
}

/** Top right corner menu in the layout. Contains Options, Logout buttons, AppVersion component and custom items container. */
@inject("auth")
@observer
export class UserMenu extends React.Component<UserMenuProps> {
  public state = {
    anchorEl: null
  };

  constructor(props: UserMenuProps) {
    super(props);
  }

  public render() {
    const { buttonConfig = { logout: true, options: true } } = this.props;
    return (
      <div style={{ marginLeft: "auto" }}>
        <Hidden xsDown={true}>
          <Button disabled={true}>
            <Typography color="inherit">
              {" "}
              {this.props.auth && this.props.auth.username
                ? this.props.auth.username
                : ""}
            </Typography>
          </Button>
        </Hidden>
        <AppVersion />
        {this.props.customMenuItems}
        {buttonConfig.options && (
          <Link to="/admin/me">
            <IconButton
              aria-label="Options"
              onClick={this.goToOptions}
              color={"inherit"}
            >
              <Build />
            </IconButton>
          </Link>
        )}
        {buttonConfig.logout && (
          <IconButton
            aria-label="Logout"
            onClick={this.logout}
            color={"inherit"}
          >
            <PowerSettingsNew />
          </IconButton>
        )}
      </div>
    );
  }

  public goToOptions = () => {
    log.debug("clicked");
  };

  public logout = () => {
    this.props.auth!.logout();
  };
}
